<section class="billing-control-subscriber-steps">
  <div class="billing-control-subscriber-steps__intro">
    <p class="billing-control-subscriber-steps__description">{{ description }}</p>
    <p
      class="billing-control-subscriber-steps__round-hint"
      *ngIf="paymentRoundId"
    >
      Filtrando pela rodada <strong>#{{ paymentRoundId }}</strong>
    </p>
    <p
      class="billing-control-subscriber-steps__round-hint"
      *ngIf="!paymentRoundId"
    >
      Nenhuma rodada selecionada — mostrando todas as pessoas nesta etapa.
    </p>
  </div>

  <div class="billing-control-subscriber-steps__toolbar">
    <div
      class="billing-control-subscriber-steps__filter"
      *ngIf="showActivationFilters"
    >
      <label for="activation-filter">
        Filtrar por situação
        <i
          class="pi pi-question-circle"
          pTooltip="Use para achar rápido quem está sem token ou com edição já criada."
          tooltipPosition="top"
        ></i>
      </label>
      <p-dropdown
        inputId="activation-filter"
        [options]="activationFilterOptions"
        [(ngModel)]="activationFilter"
        (onChange)="onActivationFilterChange()"
        [style]="{ minWidth: '14rem' }"
      />
    </div>

    <button
      *ngIf="cronJobName"
      pButton
      type="button"
      label="Processar esta etapa agora"
      icon="pi pi-refresh"
      class="p-button-outlined p-button-secondary"
      [disabled]="isActionLoading"
      pTooltip="Pega quem está parado nesta etapa e manda processar de novo (Validação ou Cobrança)."
      tooltipPosition="top"
      (click)="confirmTriggerCronJob($event)"
    ></button>
  </div>

  <div class="billing-control-subscriber-steps__summaries" *ngIf="step === 1">
    <p class="billing-control-subscriber-steps__summaries-note">
      Totais da fila desta etapa
      <ng-container *ngIf="paymentRoundId !== null"> (rodada #{{ paymentRoundId }})</ng-container
      ><ng-container *ngIf="paymentRoundId === null"> (todas as rodadas)</ng-container>.
    </p>
    <p class="billing-control-subscriber-steps__summaries-loading" *ngIf="isSummariesLoading">
      Carregando totais...
    </p>

    <ng-container *ngIf="!isSummariesLoading && queueTabSummary">
      <div class="billing-control-subscriber-steps__overview-grid">
        <article class="billing-control-subscriber-steps__overview-card">
          <span class="billing-control-subscriber-steps__summary-total">{{
            queueTabSummary.totalSubscribers | number
          }}</span>
          <span class="billing-control-subscriber-steps__summary-label"
            >Na fila de cobrança</span
          >
        </article>
        <article class="billing-control-subscriber-steps__overview-card">
          <span class="billing-control-subscriber-steps__summary-total">{{
            formatCurrency(queueTabSummary.totalAmount)
          }}</span>
          <span class="billing-control-subscriber-steps__summary-label">Valor total</span>
        </article>
      </div>

      <div class="billing-control-subscriber-steps__summary-section">
        <p class="billing-control-subscriber-steps__summaries-title">Por gateway</p>
        <div
          class="billing-control-subscriber-steps__summary-grid"
          *ngIf="(queueTabSummary.byGateway?.length ?? 0) > 0"
        >
          <article
            class="billing-control-subscriber-steps__summary-card"
            *ngFor="let summary of queueTabSummary.byGateway"
          >
            <span class="billing-control-subscriber-steps__summary-total">{{
              summary.total | number
            }}</span>
            <span class="billing-control-subscriber-steps__summary-amount">{{
              formatCurrency(summary.totalAmount)
            }}</span>
            <span
              class="billing-control-subscriber-steps__summary-message"
              [title]="summary.label"
              >{{ summary.label }}</span
            >
          </article>
        </div>
        <p
          class="billing-control-subscriber-steps__summaries-empty"
          *ngIf="(queueTabSummary.byGateway?.length ?? 0) === 0"
        >
          Ninguém nesta fila no momento.
        </p>
      </div>

      <div class="billing-control-subscriber-steps__summary-section">
        <p class="billing-control-subscriber-steps__summaries-title">Por plano</p>
        <div
          class="billing-control-subscriber-steps__summary-grid"
          *ngIf="(queueTabSummary.byPlan?.length ?? 0) > 0"
        >
          <article
            class="billing-control-subscriber-steps__summary-card"
            *ngFor="let summary of queueTabSummary.byPlan"
          >
            <span class="billing-control-subscriber-steps__summary-total">{{
              summary.total | number
            }}</span>
            <span class="billing-control-subscriber-steps__summary-amount">{{
              formatCurrency(summary.totalAmount)
            }}</span>
            <span
              class="billing-control-subscriber-steps__summary-message"
              [title]="summary.label"
              >{{ summary.label }}</span
            >
          </article>
        </div>
        <p
          class="billing-control-subscriber-steps__summaries-empty"
          *ngIf="(queueTabSummary.byPlan?.length ?? 0) === 0"
        >
          Nenhum plano nesta fila.
        </p>
      </div>
    </ng-container>
  </div>

  <div
    class="billing-control-subscriber-steps__summaries"
    *ngIf="step !== 1"
  >
    <p class="billing-control-subscriber-steps__summaries-note">
      Totais desta etapa
      <ng-container *ngIf="paymentRoundId !== null"> (rodada #{{ paymentRoundId }})</ng-container
      ><ng-container *ngIf="paymentRoundId === null"> (todas as rodadas)</ng-container>.
    </p>
    <p class="billing-control-subscriber-steps__summaries-title">
      Situações mais comuns
      <i
        class="pi pi-question-circle"
        pTooltip="Agrupa as pessoas desta etapa pela última mensagem registrada, no mesmo escopo da rodada selecionada."
        tooltipPosition="top"
      ></i>
    </p>

    <p class="billing-control-subscriber-steps__summaries-loading" *ngIf="isSummariesLoading">
      Carregando totais...
    </p>

    <div
      class="billing-control-subscriber-steps__summary-grid"
      *ngIf="!isSummariesLoading && messageSummaries.length > 0"
    >
      <article
        class="billing-control-subscriber-steps__summary-card"
        *ngFor="let summary of messageSummaries"
      >
        <span class="billing-control-subscriber-steps__summary-total">{{
          summary.total | number
        }}</span>
        <span
          class="billing-control-subscriber-steps__summary-message"
          [title]="summary.lastMessage"
          >{{ formatSituationMessage(summary.lastMessage) }}</span
        >
      </article>
    </div>

    <p
      class="billing-control-subscriber-steps__summaries-empty"
      *ngIf="!isSummariesLoading && messageSummaries.length === 0"
    >
      Ninguém neste passo agora.
    </p>
  </div>

  <app-table
    [lazy]="true"
    [findPage]="findPage"
    [service]="billingControlService"
    [cols]="stepCols"
    [addButton]="false"
    [exportExcel]="true"
    [exportPdf]="false"
    [showTitle]="false"
    [modelName]="step === 1 ? 'pessoas na cobrança' : 'pessoas nesta etapa'"
    sortField="dateUpdated"
    [sortOrder]="-1"
    [defaultRows]="20"
  />
</section>
